<ng-container *ngrxLet="vm$ as vm">
  @if (vm.discussion) {
    <ion-header class="nty-detail-header">
      <ion-toolbar>
        <nty-back-button slot="start" [text]="vm.backButtonText" [defaultHref]="nav.getDiscussionsRoute()" />
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <!-- Status badge -->
      <div class="badge-container">
        @if (vm.discussion | overdue) {
          <terra-status-badge color="warning">
            <terra-icon icon="exclamation-mark" />
            Overdue
          </terra-status-badge>
        } @else {
          <nty-discussion-status-badge [discussion]="vm.discussion" />
        }
      </div>

      <form [formGroup]="form">
        <!-- Title -->
        <nty-title
          formControlName="title"
          placeholder="Title your Discussion"
          context="edit"
          [readonly]="!vm.isEditing" />

        <div id="due-date-with-participants-container">
          <nty-discussion-form-participants [discussion]="vm.discussion" />
          <span class="vertical-divider"></span>
          <p class="terra-body-small due-date">Due {{ vm.discussion.dueDate | date: 'MMM d' }}</p>
        </div>

        <!-- Description -->
        @if (form.controls.description.value || vm.isEditing) {
          <nty-description formControlName="description" placeholder="Add a description" context="edit" />
        }

        <!-- Time period -->
        <ion-text class="ctrl-label terra-body">Time period</ion-text>
        <div class="time-period-ctrl-container mb-24">
          <nty-date-picker
            formControlName="periodStartDate"
            [class.editing]="vm.isEditing"
            [formatOptions]="dateFormat()"
            [disabled]="form.controls.periodStartDate.disabled" />

          <span class="terra-body">to</span>

          <nty-date-picker
            formControlName="periodEndDate"
            [class.editing]="vm.isEditing"
            [formatOptions]="dateFormat()"
            [disabled]="form.controls.periodEndDate.disabled" />
        </div>

        <!-- Due date -->
        <ion-text class="ctrl-label terra-body">Due date</ion-text>
        <nty-date-picker class="mb-24" formControlName="dueDate" [disabled]="!vm.isEditing" />

        <nty-discussion-participants-status [discussion]="vm.discussion" />

        <nty-attachments [parentType]="vm.attachmentParentType" [item]="vm.discussion" />
      </form>
    </ion-content>

    @if (vm.isManager) {
      <ion-footer class="nty-detail-footer">
        <ion-toolbar>
          <nty-discussion-detail-footer
            [disableSave]="form.invalid"
            [disableEdit]="vm.isDiscussionDone"
            [isEditing]="vm.isEditing"
            (save)="onSave(); save()"
            (edit)="onEdit(); toggleFormCtrls(vm.discussion)"
            (delete)="delete(vm.discussion)"
            (revert)="onRevert(); revert()"
            (universalCreateOpened)="openUniversalCreateModal()" />
        </ion-toolbar>
      </ion-footer>
    }
  } @else {
    <nty-loading />
  }
</ng-container>
